import { render, staticRenderFns } from "./configuration-local-accounting-billable-clients-modal-rates-grid.vue?vue&type=template&id=b560cf2c&"
import script from "./configuration-local-accounting-billable-clients-modal-rates-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-clients-modal-rates-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports